import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import {
  LMContextService,
  LMFormatUtilService,
  LMLoggerService,
  LMModalOpenService,
  LMModalWrapperService,
  LMUrlUtilService
} from '@app/services';
import { LMReportSecurityRequest, LMReportSecurityResponse } from '../lm-reports';
import { LMFormContext } from '@form/services';
import { LMDialogButtonKey, LMUniqueIdService } from '@app/utils';
import { LMActionFormDialogResult, LMActionFormDialogResultCode, LMReportsSecurityComponent } from '@app/components';
import { LMTransactionService } from '@app/transaction';

@Injectable()
export class LMReportSecurityService {

  constructor(
    private http: HttpClient,
    private lmLoggerService: LMLoggerService,
    private lmUrlUtilService: LMUrlUtilService,
    protected lmUniqueIdService: LMUniqueIdService,
    protected lmTransactionService: LMTransactionService,
    private  lmFormatUtilService: LMFormatUtilService,
    private lmContextService: LMContextService,
    private lmModalWrapperService: LMModalWrapperService,
    private lmModalOpenService: LMModalOpenService) {
  }

  public openReportSecurityDialog(request: LMReportSecurityRequest, formContext: LMFormContext, actionSpec: LMActionSpec): Observable<boolean> {
    return new Observable<boolean>(observer => {
      let reportsComponent: LMReportsSecurityComponent;
      const formName = 'reportSecurity';

      const buttons = [];
      buttons.push(
        {
          id: this.lmUniqueIdService.uniqueId([ formName, LMDialogButtonKey.CLOSE ]),
          text: Soho.Locale.translate(LMDialogButtonKey.CLOSE),
          click: () => {
            const result = {
              result: LMActionFormDialogResultCode.ACTION_FORM_DIALOG_CANCEL
            } as LMActionFormDialogResult;

            observer.next(false);
            observer.complete();
            modalRef.close();
          },
        }
      );

      buttons.push(
        {
          id: this.lmUniqueIdService.uniqueId([ formName, LMDialogButtonKey.OK ]),
          text: Soho.Locale.translate(LMDialogButtonKey.OK),
          click: () => {

            const dataView = reportsComponent.getDataView();

            const result = {
              result: LMActionFormDialogResultCode.ACTION_FORM_DIALOG_OK
            } as LMActionFormDialogResult;
            observer.next(true);
            this.lmTransactionService.runActionForm(formContext, actionSpec, dataView, [ dataView ]).subscribe(value => {
              observer.next(true);
              observer.complete();
              modalRef.close();
            });

          },
          isDefault: true,
        }
      );

      const title = this.lmFormatUtilService.formatMessage(Soho.Locale.translate('ReportAccessibilityFor'), request.role);

      const attributes: SohoAttributesArray = [ {
        name: 'data-automation-id',
        value: `lm-report-security-modal`
      } ];

      const sohoModalOptions: SohoModalOptions = {
        fullsize: 'always',
        attributes
      };

      const modalRef = this.lmModalWrapperService.modal(LMReportsSecurityComponent, sohoModalOptions)
        .title(title)
        .buttons(buttons)
        .isAlert(false)
        .open()
        .apply((dialogComponent: LMReportsSecurityComponent) => {
          reportsComponent = dialogComponent;
          reportsComponent.options = request;
        })
        .beforeClose(() => {
          if (this.lmContextService.isUnified()) {
            this.lmModalOpenService.removeModal(modalRef.uuid);
          }
          // if ref.dialogResult is undefined, the escape key was used
          if (!modalRef.dialogResult) {
            observer.next(false);
            observer.complete();
            return true;
          }
        });
    });
  }

  public getReportSecurityData(request: LMReportSecurityRequest): Observable<LMReportSecurityResponse> {
    const url = this.buildDataUrl(request);

    const params = {
      requestType: 'reportSecurity',
      role: request.role
    };

    return <Observable<LMReportSecurityResponse>>this.http.post(url, params).pipe(
      catchError(error => {
        this.lmLoggerService.error(error);
        return throwError(error || 'Server error');
      }));
  }

  private buildDataUrl(request: LMReportSecurityRequest): string {
    const url =  this.lmUrlUtilService.getBaseUrl() + '/report/catalog?requestType=reportSecurity&role=' + request.role; // adding this to url param for tracking usage
    return this.lmUrlUtilService.updateContextSessionKeyParams(url);
  }
}
